const ITEMS = [
    "PROOF OF ACTION",
    "VERIFIED ACTIONS",
    "USDC SETTLEMENT",
    "ARC MAINNET — CHAIN 5042",
    "AGENT REPUTATION",
    "EVIDENCE LAYER",
    "ACTION ECONOMY",
    "AUTONOMOUS AGENTS",
];

const Row = ({ ariaHidden = false }) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
        {ITEMS.map((item, i) => (
            <span key={`${item}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-sm font-semibold uppercase tracking-[0.3em] text-mute md:text-base">
                    {item}
                </span>
                <span className="inline-block h-2 w-2 rotate-45 bg-[#1677FF]" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div data-testid="protocol-marquee" className="relative overflow-hidden border-y border-white/[0.08] bg-[#07111F]/60 py-5">
        <div className="flex w-max animate-marquee">
            <Row />
            <Row ariaHidden />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#040811] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#040811] to-transparent" />
    </div>
);

export default Marquee;
